import usePageRouter from '../../hooks/@lore/dialogs-routable/_hooks/usePageRouter';
import useDialogRouter from '../../hooks/@lore/dialogs-routable/_hooks/useDialogRouter';

export default function useRouter(props) {
  const pageRouter = usePageRouter();
  const dialogRouter = useDialogRouter();

  return dialogRouter || pageRouter;
}
